import React from 'react'
import PropTypes from 'prop-types'

const ShowValue = ({ value }) => {
    const valueToString = () => {
        if (value === '' || value === null || typeof value === 'undefined') return '(vazio)'
        if (typeof value === 'string') return value
        if (Array.isArray(value)) return value.join(', ')
        if (typeof value === 'object') return JSON.stringify(value)
        if (typeof value === 'boolean') return `${value}`
        return value
    }
    return <>{valueToString()}</>
}

ShowValue.propTypes = {
    value: PropTypes.any,
}

export default ShowValue
